import { ListEnd } from 'lucide-react';

/** 1.9.3: the Follow toggle of a list (the Log and Subtitles tabs, the sequence editor's subtitles). */
export function FollowButton({ on, onChange, testId }: { on: boolean; onChange: (on: boolean) => void; testId: string }) {
  return (
    <button type="button" className={`btn ghost icon sm ${on ? 'on' : ''}`} aria-pressed={on} aria-label="Follow the playhead"
      title="Follow the playhead: scroll the list as it plays. Scrolling by hand stops it until you play again."
      onClick={() => onChange(!on)} data-testid={testId}><ListEnd size={14} /></button>
  );
}
